const items = ["Laptops", "Desktops", "Screens", "Batteries", "Keyboards", "Board repair", "Upgrades", "Data rescue", "Open Mon–Fri 7am – 6pm"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className={`px-8 font-display text-5xl font-extrabold uppercase tracking-tight md:text-8xl ${i % 2 ? "text-outline" : "text-bone"}`}>
          {t}
        </span>
        <span className="h-3 w-3 rotate-45 bg-ember md:h-4 md:w-4" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/[0.06] py-10 md:py-14">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </section>
);
